import { Component, inject } from '@angular/core';
import { ZoneTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ZoneTypeCreateDto,
  ZoneTypeDto,
  ZoneTypeExcelDownloadDto,
  ZoneTypeUpdateDto,
} from '../proxy/controlling/dtos/zone-type';
import { ZONETYPE_CONFIG, ZONETYPE_FIELDS } from './zone-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-zone-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ZoneTypeService, ConfirmationService],
  templateUrl: './zone-type.html',
  styleUrl: './zone-type.scss',
})
export class ZoneType extends BaseCrudComponent<
  ZoneTypeDto,
  ZoneTypeCreateDto,
  ZoneTypeUpdateDto,
  ZoneTypeExcelDownloadDto
> {
  service = inject(ZoneTypeService);
  config = ZONETYPE_CONFIG;
  fields = ZONETYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ZoneTypeDto): ZoneTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      description: data.description,
      tariffsModuleId: data.tariffsModuleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ZoneType';
  }
}
